/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h2[_ngcontent-%COMP%]{font-family:Nunito-Bold;font-size:20px;font-weight:500;letter-spacing:.005em;margin-bottom:0;margin-top:.83em}"];
export { styles as styles };
